import firebase from 'firebase'

const firebaseConfig = {
    apiKey: "AIzaSyCVJj1v2H4CTU-fh_4a9OK02XKHDxH-0WE",
    authDomain: "livlife-5ad11.firebaseapp.com",
    projectId: "livlife-5ad11",
    storageBucket: "livlife-5ad11.appspot.com",
    messagingSenderId: "989430220969",
    appId: "1:989430220969:web:517c26407b9e5329b781b8"
  };

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const provider = new firebase.auth.GoogleAuthProvider();